import Api from '../global/api';

export function pedestalsLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'PEDESTALS_LOAD',
            status: 'LOADING',
            payload: null
        })


        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/pedestals/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('pedestals', res.result);

                    dispatch({
                        type: 'PEDESTALS_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'PEDESTALS_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your pedestals'
                    })
                }
            )
        }

    }
}

export function pedestalAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'PEDESTAL_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function pedestalUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'PEDESTAL_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}